import { postPanUtility } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKycPanUtilityThunk = createAsyncThunk(
  "reKycPanUtilityThunk",
  async ({ params, token }, { rejectWithValue }) => {
    try {
      const response = await postPanUtility(params, token);

      if (response?.code !== 200) {
        return rejectWithValue({
          code: response.code,
          message: response.message,
          data: response.data,
        });
      }

      return response;
    } catch (error) {
      // Check if fullError exists (new interceptor)
      if (error?.fullError) {
        return rejectWithValue({
          code: error.fullError.code,
          message: error.fullError.message,
          data: error.fullError.data || {},
        });
      }

      // Fallback for old behavior
      return rejectWithValue({
        message:
          typeof error === "string" ? error : error?.message || "Network error",
        data: {},
      });
    }
  }
);
